
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"d":"M15.5 5.643 11.046 8.5l4.454 2.857zM9.773 4.5h-7C2.07 4.5 1.5 5.012 1.5 5.643v5.714c0 .631.57 1.143 1.273 1.143h7c.703 0 1.273-.512 1.273-1.143V5.643c0-.631-.57-1.143-1.273-1.143","stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    